export class GrLineItemFieldsDTO{
  public quantity?:string
  public batch_no?:string
  public material_code?:string
  public material_description?:string
  public uom?:string
  public storage_location?:string
  public gate_entry_quantity?:string
  public ok_quantity?:string
  public reject_quantity?:string
}

export class VendorFieldsDTOForGR{
  public business_name?:string
  public vendor_code?:string
}

export class POFieldsDTOForGR{
  public poagreement_no?:string
}

export class ItemFieldsDTOForSchedule{
  public item_no?:string
  public quantity?:string
}
export class GRSearchDTO{
  public gr_no?:string
  public gr_date?:string
  public gate_entry_no?:string
  public plant?:string
  public gate_entry_date?:string
  public invoice_no?:string
  public invoice_date?:string
  public status?:string
}
